import React from 'react';
import ClosePayable from '../../../../common/poppers/ClosePayable';
import DeleteObject from '../../../../common/poppers/DeleteObject';
import PayableDetail from '../../../../common/poppers/details/PayableDetail';
import GroupForPayable from '../../../../common/poppers/GroupForPayable';
import ManualMatcherForPayable from '../../../../common/poppers/ManualMatcherForPayable';
import Matcher from '../../../../common/poppers/MatcherForPayable';
import RemovePayableFromGroup from '../../../../common/poppers/RemovePayableFromGroup';
import ModifyRestrain from './ModifyRestrain';
import RestrainRow from './RestrainRow';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import LinkIcon from '@material-ui/icons/Link';
import LinkOffIcon from '@material-ui/icons/LinkOff';

export const restrainActionItems = [
    {
        dataDialog: "modify-dialog",
        title: "Módosít",
        dialogTitle: "Letiltás módosítása",
        icon: <EditIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <ModifyRestrain {...props} close={close} />
    },
    {
        dataDialog: "close-dialog",
        title: "Lezárás",
        dialogTitle: "Fizetés Lezárása",
        canShow: (row) => "PAID" !== row.state && "CLOSED" !== row.state,
        actionComponent: (props, close) => <ClosePayable {...props} close={close} path={'/api/manualclose/payable'} isClose={true} confirm={"Biztos hogy le szeretnéd zárni?"} comp={<RestrainRow {...props} />} />
    },
    {
        dataDialog: "close-dialog",
        title: "Újranyitás",
        dialogTitle: "Fizetés Újranyitása",
        canShow: (row) => "CLOSED" === row.state,
        actionComponent: (props, close) => <ClosePayable {...props} close={close} path={'/api/manualclose/payable'} isClose={false} confirm={"Biztos hogy újra szeretnéd nyitni?"} comp={<RestrainRow {...props} />} />
    },
    {
        dataDialog: "detail-dialog",
        title: "Részletek",
        dialogTitle: "Részletek",
        width: "lg",
        icon: <FilterListIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <PayableDetail {...props} close={close} row={props.row} billtype={props.tabletype} />
    },
    {
        divider: true,
    },
    {
        dataDialog: "transaction-dialog",
        title: "Tranzakció linkel",
        dialogTitle: "Linkel",
        icon: <LinkIcon fontSize="small" color="primary" />,
        canShow: (row) => "MATCH_FOUND" === row.state,
        actionComponent: (props, close) => <Matcher {...props} close={close} row={props.row} billtype={props.tabletype} />
    }, 
    {
        dataDialog: "transaction-dialog",
        title: "Manuális tranzakció linkel",
        dialogTitle: "Manuális linkel",
        icon: <LinkIcon fontSize="small" color="primary" />,
        canShow: (row) => "NEW" === row.state || "INCOMPLETE" === row.state,
        actionComponent: (props, close) => <ManualMatcherForPayable {...props} close={close} row={props.row} billtype={props.tabletype} />
    }, 
    {
        dataDialog: "group-dialog",
        title: "Letiltás linkel",
        dialogTitle: "Letiltás linkel",
        icon: <LinkIcon fontSize="small" color="primary" />,
        canShow: (row) => "PAID" !== row.state && "CLOSED" !== row.state && !row.groupPublicId,
        actionComponent: (props, close) => <GroupForPayable {...props} close={close} row={props.row} billtype={props.tabletype} />
    }, 
    {
        dataDialog: "remove-group-dialog",
        title: "Csoportból eltávolít",
        dialogTitle: "Csoportból eltávolít",
        icon: <LinkOffIcon fontSize="small" color="primary" />,
        canShow: (row) => row.groupPublicId,
        actionComponent: (props, close) => <RemovePayableFromGroup {...props} close={close} row={props.row} billtype={props.tabletype} />
    },
    {
        divider: true,
    },
    {
        dataDialog: "delete-dialog",
        title: "Törlés",
        dialogTitle: "Letiltás törlése",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/restrain'} comp={<RestrainRow {...props} />} />
    }
]